import { Link } from "react-router-dom";
import { PageHero } from "@/components/PageHero";
import { ArrowRight } from "lucide-react";

const STANDARDS = [
  {
    title: "Editorial Independence",
    copy: "Atlantic Bridge Institute controls its own editorial decisions. Partnerships, funding and institutional relationships never determine what we publish, and material support is disclosed where it exists.",
  },
  {
    title: "Accuracy and Verification",
    copy: "We do not publish statistics, claims or quotations that cannot be verified against primary sources. Where research is still in progress, our pages say so plainly rather than filling gaps with assertion.",
  },
  {
    title: "Corrections",
    copy: "When we get something wrong, we say so. Substantive errors are corrected promptly and the correction is noted on the page. To request a correction, use our contact form and select “Corrections” as your reason.",
  },
  {
    title: "Transparency",
    copy: "We identify our authors, label analysis as analysis, and distinguish verified reporting from work in progress. We do not invent partners, testimonials, events or sources.",
  },
  {
    title: "Privacy",
    copy: "Contact form submissions and newsletter signups are used only for the purpose for which they were sent. We do not sell or share personal information with third parties.",
  },
];

export default function EditorialStandardsPage() {
  return (
    <main data-testid="editorial-standards-page">
      <PageHero
        kicker="Editorial Standards"
        title="How We Work"
        copy="The standards below govern every story, dossier and research product Atlantic Bridge publishes."
      />
      <section className="bg-sand py-20 lg:py-28">
        <div className="mx-auto max-w-4xl px-5 lg:px-8">
          {STANDARDS.map((s, i) => (
            <div key={s.title} data-testid={`standard-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="flex gap-8 border-b border-atlantic/10 py-10 first:border-t">
              <span className="font-serif text-sm text-gold">{String(i + 1).padStart(2, "0")}</span>
              <div>
                <h2 className="font-serif text-xl tracking-tight text-atlantic sm:text-2xl">{s.title}</h2>
                <p className="mt-4 text-base leading-relaxed text-slate-600">{s.copy}</p>
              </div>
            </div>
          ))}
          <Link
            to="/contact"
            data-testid="standards-contact-button"
            className="group mt-12 inline-flex items-center gap-2 bg-atlantic px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-atlantic-light"
          >
            Raise a Standards or Corrections Enquiry
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </section>
    </main>
  );
}
